import { gql } from '@apollo/client';

export const CHECK_EXISTING_USER = gql`
    query CheckForExistingUser($field: String, $value: String) {
        checkForExistingUser(field: $field, value: $value) {
            data {
                exist_user
            }
            error {
                message
            }
        }
    }
`;
export const fetchUser = gql`
    query FetchUsers($status:String) {
        fetchUsers(status: $status) {
            data {
            users {
                name
                email
                id
                status
                user_identifier
                mobile_no
                created_at
                roles {
                    id
                    name
                    description
                }
                updated_at
            }
        }
        error {
            field
            message
            code
        }
        }
    }
`;